import('./bootstrap')
  .then(({ bootstrap }) => bootstrap())
  .then(() => window.dispatchEvent(new Event('moosj:ready')))
  .catch((error: unknown) => {
    console.error(error);
    window.dispatchEvent(new CustomEvent('moosj:recovery', {
      detail: { kind: 'startup' },
    }));
  });
